import { Controller } from '@hotwired/stimulus'
import { escapeHTML } from '../utilities'

export default class extends Controller {
  static targets = ['recentArticles', 'recentArticleTemplate']

  static values = {
    articleData: Object,
    id: String,
    isArticlePage: Boolean,
    locale: { type: String, default: 'en' }
  }

  connect() {
    this.localStorageKey = `history:${this.idValue}`
    this.history = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
    if (this.isArticlePageValue) this.#storeArticleData()

    if (this.history.length && this.hasRecentArticlesTarget) {
      this.#populateRecentArticlesHTML()
    }
  }

  #buildEntryHTML(entry, templateId) {
    const { title, link_title, subtitle, image, path, subcategory } = entry

    const template = this.recentArticleTemplateTargets.find(template => {
      if (subcategory) {
        return (
          template.dataset.id === templateId &&
          template.dataset.subcategory === subcategory
        )
      } else {
        return template.dataset.id === templateId
      }
    })

    if (!template) return

    const entryHTML = template.content.cloneNode(true)

    if (templateId === 'search-entry') {
      const imageContainer = entryHTML.querySelector('.search-result-image')
      const imageFallback = entryHTML.querySelector(
        '.search-result-image-fallback'
      )

      if (imageContainer) {
        imageContainer.innerHTML = ''

        if (image) {
          const imgEl = document.createElement('img')
          imgEl.src = image
          imgEl.alt = ''
          imgEl.className = 'object-cover size-full'
          imageContainer.appendChild(imgEl)
          imageContainer.classList.remove('hidden')
          imageFallback?.classList.add('hidden')
        } else {
          imageContainer.classList.add('hidden')
          imageFallback?.classList.remove('hidden')
        }
      }

      entryHTML.querySelector('a').href = path
      entryHTML.querySelector('.article-title').textContent = link_title
      entryHTML.querySelector('.article-subtitle').textContent = subtitle
    } else {
      const a = entryHTML.querySelector('a')
      a.href = path

      a.dataset.tippyContent = `<h4>${escapeHTML(title)}</h4><p>${escapeHTML(subtitle)}</p>`

      a.dataset.tippyTheme = 'doc-link'
      entryHTML.querySelector('span').textContent = link_title

      const subtitleEl = entryHTML.querySelector('.article-subtitle')
      if (subtitleEl) subtitleEl.textContent = subtitle
    }

    return entryHTML
  }

  #populateRecentArticlesHTML() {
    const hasEntryForLocale = this.history.some(
      entry => this.localeValue in entry.locales
    )

    if (!hasEntryForLocale) return

    this.recentArticlesTargets.forEach(target => {
      const ul = target.querySelector('ul')
      const templateId = target.dataset.articleHistoryTemplateId

      this.history.slice(0, 3).forEach(entry => {
        const entryLocaleData = entry.locales[this.localeValue]

        if (entryLocaleData) {
          const entryHTML = this.#buildEntryHTML(entryLocaleData, templateId)
          ul.appendChild(entryHTML)
        }
      })

      target.hidden = false
    })
  }

  #storeArticleData() {
    // move repeat page visits to the front
    const repeatVisitIndex = this.history.findIndex(
      entry => entry.id === this.articleDataValue.id
    )

    if (repeatVisitIndex > -1) this.history.splice(repeatVisitIndex, 1)
    this.history.unshift(this.articleDataValue)

    localStorage.setItem(this.localStorageKey, JSON.stringify(this.history))
  }
}
